export default __webpack_public_path__ + "static/kubernetes-logo-08dda7b22292b0772303f920ef4702cb.svg";